import React from 'react';
import { useSelector } from 'react-redux';
import { Select } from 'components';
import { InputRows } from 'components';
import DateRange from '../../components/date-range';
import Subqueries from '../../components/sub-queries';

export default function Filter({ stateName }) {
  const {
    waterQuality: {
      waterPreparantion: { historicLog },
    },
  } = useSelector(({ state }) => state);

  const { yearStart, yearEnd, weekStart, weekEnd } = historicLog;
  return (
    <Subqueries
      stateName={stateName}
      yearStart={yearStart}
      yearEnd={yearEnd}
      weekEn={weekStart}
      weekStart={weekEnd}
      children
    >
      {({ loading: subLoading, error, data: subqueries }) => {
        return [
          <InputRows key={1}>
            <DateRange stateName={stateName} hideMonth hideDay />
            <Select
              stateName={`${stateName}.dataPoint`}
              default={subqueries?.devices[0]}
              data={subqueries?.devices?.map((value) => ({ value }))}
              loading={subLoading}
            />
          </InputRows>,
        ];
      }}
    </Subqueries>
  );
}
